import React, { type ReactNode, memo } from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';
import AppsIcon from '@atlaskit/icon/core/apps';
import EditIcon from '@atlaskit/icon/core/edit';
import FilesIcon from '@atlaskit/icon/core/files';
import TaskIcon from '@atlaskit/icon/core/task';
import GlobeIcon from '@atlaskit/icon/core/globe';
import SpacesIcon from '@atlaskit/icon-lab/core/spaces';

import { expVal } from '@confluence/feature-experiments';

import type { MenuId } from './PlatformNavigationTypes.ts';

type StyledIconComponentProps = {
	icon: { (props: NewCoreIconProps, displayName: string) };
};

const StyledIconComponent = memo(({ icon }: StyledIconComponentProps) => {
	const IconComponent = icon;
	return <IconComponent label="" color="currentColor" spacing="spacious" />;
});

export const platformNavigationIcons: { [key in MenuId]?: ReactNode } = {
	drafts: <StyledIconComponent icon={EditIcon} />,
	templates: <StyledIconComponent icon={FilesIcon} />,
	tasks: <StyledIconComponent icon={TaskIcon} />,
	spaces: <ConditionalSpacesIcon />,
	apps: <StyledIconComponent icon={AppsIcon} />,
};

function ConditionalSpacesIcon() {
	if (expVal('confluence_space_icon_update', 'isEnabled', false)) {
		return <StyledIconComponent icon={SpacesIcon} />;
	}

	return <StyledIconComponent icon={GlobeIcon} />;
}
